import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import TopGCollection from './pages/TopGCollection';
import MutantCollection from './pages/MutantCollection';
import XWarCollection from './pages/XWarCollection';
import LadiesCollection from './pages/LadiesCollection';
import MulaTreeCollection from './pages/MulaTreeCollection';
import PrivateJetCollection from './pages/PrivateJetCollection';
import PixelCollection from './pages/PixelCollection';
import OGCollection from './pages/OGCollection';

function App() {
  return (
    <Router>
      <div className='App'>
        <Navbar />
        <main>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/og-apes' element={<OGCollection />} />
            <Route path='/private-jet-apes' element={<PrivateJetCollection />} />
            <Route path='/xwar-apes' element={<XWarCollection />} />
            <Route path='/top-g-apes' element={<TopGCollection />} />
            <Route path='/mutants' element={<MutantCollection />} />
            <Route path='/pixel-apes' element={<PixelCollection />} />
            <Route path='/mula-trees' element={<MulaTreeCollection />} />
            <Route path='/ladies' element={<LadiesCollection />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
